import * as types from '@/store/types';

const offsetValue = 55;

const initialState = {
    info: {
        offset: offsetValue,
    },
    warning: {
        offset: offsetValue,
    },
    error: {
        duration: 6000,
        showClose: true,
        offset: offsetValue,
    },
    success: {
        duration: 2000,
        offset: offsetValue,
    },
    apiError: {
        type: 'error',
        message: 'Internal Server Error',
        duration: 6000,
        showClose: true,
        offset: offsetValue,
    },
    saveSuccess: {
        type: 'success',
        message: 'Saving was succesful',
        duration: 2000,
        offset: offsetValue,
    },
};

const state = { ...initialState };


const mutations = {
    [types.RECEIVE_MESSAGE_PARAMS] (state, { data }) {
        state = data;
    },
};

export default {
    state,
    mutations,
};
